import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enCatalog from './locales/en/catalog.json';
import enAuth from './locales/en/auth.json';
import enOrders from './locales/en/orders.json';
import enReviews from './locales/en/reviews.json';
import enSeller from './locales/en/seller.json';
import enCart from './locales/en/cart.json';
import enWishlist from './locales/en/wishlist.json';
import enStories from './locales/en/stories.json';
import enCheckout from './locales/en/checkout.json';
import enCrm from './locales/en/crm.json';
import enProduct from './locales/en/product.json';
import enAdmin from './locales/en/admin.json';
import enLegal from './locales/en/legal.json';
import enBundles from './locales/en/bundles.json';
import enCardcom from './locales/en/cardcom.json';
import enReturns from './locales/en/returns.json';
import enSupport from './locales/en/support.json';
import enAbout from './locales/en/about.json';

import heCommon from './locales/he/common.json';
import heHome from './locales/he/home.json';
import heCatalog from './locales/he/catalog.json';
import heAuth from './locales/he/auth.json';
import heOrders from './locales/he/orders.json';
import heReviews from './locales/he/reviews.json';
import heSeller from './locales/he/seller.json';
import heCart from './locales/he/cart.json';
import heWishlist from './locales/he/wishlist.json';
import heStories from './locales/he/stories.json';
import heCheckout from './locales/he/checkout.json';
import heCrm from './locales/he/crm.json';
import heProduct from './locales/he/product.json';
import heAdmin from './locales/he/admin.json';
import heLegal from './locales/he/legal.json';
import heBundles from './locales/he/bundles.json';
import heCardcom from './locales/he/cardcom.json';
import heReturns from './locales/he/returns.json';
import heSupport from './locales/he/support.json';
import heAbout from './locales/he/about.json';

import ruCommon from './locales/ru/common.json';
import ruHome from './locales/ru/home.json';
import ruCatalog from './locales/ru/catalog.json';
import ruAuth from './locales/ru/auth.json';
import ruOrders from './locales/ru/orders.json';
import ruReviews from './locales/ru/reviews.json';
import ruSeller from './locales/ru/seller.json';
import ruCart from './locales/ru/cart.json';
import ruWishlist from './locales/ru/wishlist.json';
import ruStories from './locales/ru/stories.json';
import ruCheckout from './locales/ru/checkout.json';
import ruCrm from './locales/ru/crm.json';
import ruProduct from './locales/ru/product.json';
import ruAdmin from './locales/ru/admin.json';
import ruLegal from './locales/ru/legal.json';
import ruBundles from './locales/ru/bundles.json';
import ruCardcom from './locales/ru/cardcom.json';
import ruReturns from './locales/ru/returns.json';
import ruSupport from './locales/ru/support.json';
import ruAbout from './locales/ru/about.json';

import esCommon from './locales/es/common.json';
import esHome from './locales/es/home.json';
import esCatalog from './locales/es/catalog.json';
import esAuth from './locales/es/auth.json';
import esOrders from './locales/es/orders.json';
import esReviews from './locales/es/reviews.json';
import esSeller from './locales/es/seller.json';
import esCart from './locales/es/cart.json';
import esWishlist from './locales/es/wishlist.json';
import esStories from './locales/es/stories.json';
import esCheckout from './locales/es/checkout.json';
import esCrm from './locales/es/crm.json';
import esProduct from './locales/es/product.json';
import esAdmin from './locales/es/admin.json';
import esLegal from './locales/es/legal.json';
import esBundles from './locales/es/bundles.json';
import esCardcom from './locales/es/cardcom.json';
import esReturns from './locales/es/returns.json';
import esSupport from './locales/es/support.json';
import esAbout from './locales/es/about.json';

const resources = {
  en: {
    common: enCommon,
    home: enHome,
    catalog: enCatalog,
    auth: enAuth,
    orders: enOrders,
    reviews: enReviews,
    seller: enSeller,
    cart: enCart,
    wishlist: enWishlist,
    stories: enStories,
    checkout: enCheckout,
    crm: enCrm,
    product: enProduct,
    admin: enAdmin,
    legal: enLegal,
    bundles: enBundles,
    cardcom: enCardcom,
    returns: enReturns,
    support: enSupport,
    about: enAbout,
  },
  he: {
    common: heCommon,
    home: heHome,
    catalog: heCatalog,
    auth: heAuth,
    orders: heOrders,
    reviews: heReviews,
    seller: heSeller,
    cart: heCart,
    wishlist: heWishlist,
    stories: heStories,
    checkout: heCheckout,
    crm: heCrm,
    product: heProduct,
    admin: heAdmin,
    legal: heLegal,
    bundles: heBundles,
    cardcom: heCardcom,
    returns: heReturns,
    support: heSupport,
    about: heAbout,
  },
  ru: {
    common: ruCommon,
    home: ruHome,
    catalog: ruCatalog,
    auth: ruAuth,
    orders: ruOrders,
    reviews: ruReviews,
    seller: ruSeller,
    cart: ruCart,
    wishlist: ruWishlist,
    stories: ruStories,
    checkout: ruCheckout,
    crm: ruCrm,
    product: ruProduct,
    admin: ruAdmin,
    legal: ruLegal,
    bundles: ruBundles,
    cardcom: ruCardcom,
    returns: ruReturns,
    support: ruSupport,
    about: ruAbout,
  },
  es: {
    common: esCommon,
    home: esHome,
    catalog: esCatalog,
    auth: esAuth,
    orders: esOrders,
    reviews: esReviews,
    seller: esSeller,
    cart: esCart,
    wishlist: esWishlist,
    stories: esStories,
    checkout: esCheckout,
    crm: esCrm,
    product: esProduct,
    admin: esAdmin,
    legal: esLegal,
    bundles: esBundles,
    cardcom: esCardcom,
    returns: esReturns,
    support: esSupport,
    about: esAbout,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'home', 'catalog', 'auth', 'orders', 'reviews', 'seller', 'cart', 'wishlist', 'stories', 'checkout', 'crm', 'product', 'admin', 'legal', 'bundles', 'cardcom', 'returns', 'support', 'about'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;